// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { WarehousesObj } from "@tps/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";

export const getWarehouse = (cart: CartModel) => {
    const warehousesObj = JSON.parse(cart?.properties?.warehouses || "{}");

    const warehouses: WarehousesObj[] = Object.keys(warehousesObj).map(key => ({
        Description: warehousesObj[key]?.Description || "",
        ShipVia: warehousesObj[key]?.ShipVia || "",
        ShippingMethod: warehousesObj[key]?.ShippingMethod || "",
        ShippingTerms: warehousesObj[key]?.ShippingTerms || "",
        Notes: warehousesObj[key]?.Notes || "",
    }));

    const hasMultipleWarehouses = warehouses.length > 1;
    const hasWillCall = warehouses.some(data => data.ShipVia === "WILL CALL");
    const isSingleWarehouseWithWillCall = warehouses.length === 1 && hasWillCall;
    const firstWarehouse = JSON.parse(cart?.cartLines?.[0]?.properties?.warehouse || "{}");

    return {
        hasMultipleWarehouses,
        isSingleWarehouseWithWillCall,
        firstWarehouse,
        hasWillCall,
    };
};
